// Роли пользователя: user, superadmin, owner. Владелец может всё, что суперадмин,
// и ещё выдаёт и снимает роль суперадмина (docs/ADMIN.md).
export const isSuperadmin = (user: { role?: string | null } | null | undefined): boolean =>
  user?.role === "superadmin" || user?.role === "owner";

export const isOwner = (user: { role?: string | null } | null | undefined): boolean =>
  user?.role === "owner";
